export default "__VITE_ASSET__CUfv0Xgg__"